var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import RevealListItem from './RevealListItem';
import './main.scss';
var RevealList = function (_a) {
    var listItems = _a.listItems, footerNote = _a.footerNote;
    var isMobile = window.innerWidth < 1200;
    return (_jsxs("div", __assign({ className: "hsl-list snap-start w-auto flex-shrink flex-col" }, { children: [_jsx("ul", __assign({ className: "w-full flex-col justify-between items-start flex" }, { children: listItems.map(function (listItemData, index, listItemsArray) {
                    var lastIndex = listItemsArray.length - 1;
                    var middleIndex = Math.round(listItemsArray.length / 2) - 1;
                    var listItemProps = __assign(__assign({}, listItemData), { isLastOne: lastIndex === index, isMiddleOne: middleIndex === index, isMobile: isMobile });
                    return _jsx(RevealListItem, __assign({}, listItemProps), index);
                }) }), void 0),
            _jsx("div", { children: _jsx("small", __assign({ className: "reveal-list-item-footnote hsl-footnote font-light text-enblue flex-wrap" }, { children: footerNote }), void 0) }, void 0)] }), void 0));
};
export default RevealList;
